import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'multiYearAgreementStatus',
    standalone: true
})
export class MultiYearAgreementStatusPipe implements PipeTransform {

  transform(status: string): string {
    switch (status) {
      case 'ACTIVE':
        return 'Active';
      case 'COMPLETED':
        return 'Completed';
      case 'CANCELED':
        return 'Canceled';
      default:
        return 'Unknown';
    }
  }
}
